<template>
  <main class="thread-comments" v-if="showThreadComments">
       
    <section class="comment-post">
        <div class="comment-post__img">
            <img :src="reply.author_avatar_urls[24]" :alt="`User ${reply.author_name}`" />
        </div>
        <div class="comment-post__text">
            <cmscontent :content="`<span>${reply.author_name}</span>`"/>
            <cmscontent :content="`<small>${formatDate(reply.date)}</small>`"/>
            <cmscontent :content="`<p>${reply.content.rendered}</p>`" /> 
        </div>
        <div class="comment-post__replies">
            <div class="replies-length">
                <i class="fas fa-comment-dots"></i>
                <cmscontent :content="`<span>${replies.length}</span>`"/>
            </div>
            <div class="reply">
                <i class="fas fa-reply"></i>
                <span>Reply</span>
            </div>
        </div>
    </section>

    

  </main>
</template>

<script>

export default {

  data() {
    return {
      replies: []
    }
  },

  props: {
    reply: Object,
    showThreadComments: Boolean
  },

  methods: {
    formatDate(date) {
      let options = { 
          day: 'numeric', 
          year: 'numeric', 
          month: 'long' 
      }

      let postDate = new Date(date);

      return postDate.toLocaleDateString('en-US', options);

    },

  },


}
</script>

<style lang="scss">

@import '../../scss/settings';

.thread-comments {
  margin-left: auto;
  
  > .comment-post {
    background: rgba(0, 0, 0, .09);
    margin-bottom: rem-calc(8);

    &__text {

      & :nth-child(2) {
          margin-top: rem-calc(-8);
          font-size: rem-calc(14);
      }

    }

  }


}

.read-more {
  @extend %center-content;
  cursor: pointer;
  margin-bottom: rem-calc(10);
  text-decoration: none;
}

</style>